import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { SupportTicketFormComponent } from '../support-ticket-form/support-ticket-form.component';
import { AssignedToComponent } from '../assigned-to/assigned-to.component';
import { RemarkHistoryComponent } from '../remark-history/remark-history.component';

@Component({
  selector: 'app-ticket-assign',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, DataTablesModule, JsonPipe, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './ticket-assign.component.html',
  styleUrl: './ticket-assign.component.scss'
})
export class TicketAssignComponent {
  isDisabled: boolean = false;
  Branchs: any[] = [];
  Clients: any[] = [];
  Supervisors: any[] = [];
  Sites: any[] = [];
  ComplaintTypeData: any[] = [];
  SupportData: any[] = [];
  Filter = {
    BranchID: [],
    ClientID: [],
    SiteOwnerID: [],
    SiteID: []
  }
  FromDate: any = null;
  FromDateObj: any = null;
  ToDate: any = null;
  ToDateObj: any = null;
  public User: any = null;

  // Total: number = 0
  Close: number = 0
  Open: number = 0
  Assigned: number = 0
  Resolved: number = 0


  Count: any[] = []
  globalTotal: number = 0
  globalOpen: number = 0
  globalClose: number = 0
  globalAssign: number = 0
  globalResolved: number = 0


  selectedMonth: any = null;
  startFromDate: any = null
  startToDate: any = null
  showDate: boolean = false;
  TickecStatus: any = 'Open';
  ESS_ComplaintTypeId: any = null;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  constructor(
    private support: SupportTicketService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
  ) {
    this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  curDate() {
    const currentDate = new Date();
    const FromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const ToDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const formatDate = (date: Date) => ({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    });
    this.FromDate = formatDate(FromDate);
    this.ToDate = formatDate(ToDate);
  }

  ngOnInit(): void {
    this.curDate();
    this.getData();
    this.CountData('All');
    this.ComboLoad('ComplaintType');
    this.ComboLoad2('Branch');
    this.ComboLoad2('SiteOwner');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  getData() {
    this.SupportData = [];
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    this.ToDateObj = this.dateFormate.format(this.ToDate);
    const Detail = {
      SelectType: 'W',
      EmpMasterId: '',
      UserId: this.User.UserId,
      Status: this.TickecStatus,
      FromDate: this.showDate ? this.startFromDate : this.FromDateObj,
      ToDate: this.showDate ? this.startToDate : this.ToDateObj,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId,
      HelpDeskUserType: 'Admin'
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.SupportData = Object.values(data.Table);
        this.SupportData[0]['PriorityFlag']  === 'PRIORITY'
        console.log(this.SupportData);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.Open = this.SupportData.filter(item => item.Status.toLowerCase() === 'open').length;
        this.Close = this.SupportData.filter(item => item.Status.toLowerCase() === 'closed').length;
        this.Assigned = this.SupportData.filter(item => item.Status.toLowerCase() === 'assigned').length;
        this.Resolved = this.SupportData.filter(item => item.Status.toLowerCase() === 'resolved').length;
        this.CountData('All');
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  CountData(Status: string) {
    const Detail = {
      SelectType: 'W',
      EmpMasterId: '',
      UserId: this.User.UserId,
      Status: Status,
      FromDate: null,
      ToDate: null,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId,
      HelpDeskUserType: 'Admin'
    }
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => { 
        this.Count = data.Table;
        if (this.Count.length > 0) {
          this.globalTotal = this.Count.length;
          this.globalOpen = this.Count.filter(item => item.Status.toLowerCase() === 'open').length;
          this.globalAssign = this.Count.filter(item => item.Status.toLowerCase() === 'assigned').length;
          this.globalClose = this.Count.filter(item => item.Status.toLowerCase() === 'closed').length;
          this.globalResolved = this.Count.filter(item => item.Status.toLowerCase() === 'resolved').length;          
        }
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  ComboLoad2(Combotype: String) {
    this.isDisabled = true;
    if (true || (Combotype == 'Region') ||
      (Combotype == 'Branch') ||
      (Combotype == 'Client' && this.Filter.BranchID.length > 0) ||
      (Combotype == 'Site' && this.Filter.ClientID.length > 0) ||
      (Combotype == 'SiteOwner')) {
      this.support.ComboLoad({
        'SelectType': Combotype,
        'BranchId': this.Filter.BranchID.toString(),
        'ClientId': this.Filter.ClientID.toString(),
        'SiteId': this.Filter.SiteID.toString(),
        //'SupervisorId': this.Filter.SiteOwnerID.toString(),
        'UserId': this.User.UserId,
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            this.Branchs = response.Table;
          } else if (Combotype == 'Client') {
            this.Clients = response.Table;
          } else if (Combotype == 'SiteOwner') {
            this.Supervisors = response.Table;
          } else if (Combotype == 'Site') {
            this.Sites = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ComplaintType') {
          this.ComplaintTypeData = response.ComboLoad;
          this.isDisabled = false
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Validate(form: any) {
    if (form.valid) {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.getData();
    } else {
      form.submitted = true;
    }
  }
  onchange(type: string) {
    if (type === 'ComplaintType') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Status') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Date') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Branch') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.ClientID = []
      this.Clients = [];
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'Client') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'site') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'supervisor') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }
  onNavigate() {
    const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
    const endDate = new Date(this.selectedMonth.year, this.selectedMonth.month, 0);
    this.startFromDate = startFromDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    this.startToDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onEditClick(element: any) {
    const modalRef = this.modalService.open(SupportTicketFormComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      SelectType: 'U',
      ESS_HelpDeskRequestId: element.ESS_HelpDeskRequestID,
      ESS_ComplaintTypeId: element.ESS_ComplaintTypeId,
      AdditionalDetails: element.AdditionalDetails,
      EmpMasterId: element.EmpMasterId,
      ContactNo: element.ContactNo,
      Description: element.Description,
      UserId: this.User.UserId,
      ComplaintType: element.ComplaintType,
      EmpName: element.EmpName,
      EmpCode: element.EmpCode,
      EmpEmail: element.EmpEmail,
      EmpContact: element.EmpContact,
      BranchName: element.BranchName,
      ClientLocation: element.ClientLocation,
      SiteName: element.SiteName,
      SiteSuperVisorName: element.SiteSuperVisorName,
      SupervisorEmailId: element.SupervisorEmailId,
      SupervisorContactNo: element.SupervisorContactNo,
      DesignationName: element.DesignationName,
      Photo: element.Photo,
      Status: element.Status,
      type: 'Closed',
      Attachment:element.Attachment,
      
      assignedbyName : this.User.UserName,
      companyName : this.User.CompanyName,
      ticketRaisedDate : element.RequestedOn,
      closedtoMailId : element.Email
    };
    modalRef.result.then((result) => {
      if (result) {
        this.SupportData = [];
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.getData();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  Assign(element: any) {
    const modalRef = this.modalService.open(AssignedToComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.InputData = {
      SelectType: 'U',
      ESS_HelpDeskRequestId: element.ESS_HelpDeskRequestID,
      ESS_ComplaintTypeId: element.ESS_ComplaintTypeId,
      AdditionalDetails: element.AdditionalDetails,
      EmpMasterId: element.EmpMasterId,
      ContactNo: element.ContactNo,
      Description: element.Description,
      UserId: this.User.UserId,
      ComplaintType: element.ComplaintType,
      EmpName: element.EmpName,
      EmpCode: element.EmpCode,
      EmpEmail: element.EmpEmail,
      EmpContact: element.EmpContact,
      BranchName: element.BranchName,
      ClientLocation: element.ClientLocation,
      SiteName: element.SiteName,
      SiteSuperVisorName: element.SiteSuperVisorName,
      SupervisorEmailId: element.SupervisorEmailId,
      SupervisorContactNo: element.SupervisorContactNo,
      DesignationName: element.DesignationName,
      Photo: element.Photo,
      Status: element.Status,
      Attachment:element.Attachment,
      //toMailId : element.Email,
      // ticketID : '',
      assignedbyName : this.User.UserName,
      //ticketDescription : '',
      ticketRaisedDate : element.RequestedOn,
      companyName : this.User.CompanyName
    };
    modalRef.result.then((result) => {
      if (result) {
        this.SupportData = [];
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.getData();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  Hist(element: any) {
    const modalRef = this.modalService.open(RemarkHistoryComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      ESS_HelpDeskRequestId: element.ESS_HelpDeskRequestID,
      HelpDeskUserType: 'Admin',
    };
    modalRef.result.then((result) => {
      if (result) {
        this.getData();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'HelpDeskSupport' + '/' + Text;
  }
}
